import FormattedMessage from 'I18n/components/FormattedMessage';
import { OrderedSet } from 'immutable';
import * as SearchFields from 'SalesContentIndexUI/data/constants/SearchFields';
import TableColumnRecord from 'SalesContentIndexUI/data/records/TableColumnRecord';
import { jsx as _jsx } from "react/jsx-runtime";
const NameColumn = TableColumnRecord({
  id: 'name',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "table.columnNames.name"
  }),
  searchField: SearchFields.NAME_FIELD
});
const LinksCreatedColumn = TableColumnRecord({
  id: 'shares',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "table.columnNames.linksCreated"
  }),
  searchField: '',
  width: 100
});
const ViewsColumn = TableColumnRecord({
  id: 'views',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "table.columnNames.views"
  }),
  searchField: '',
  width: 100
});
const OwnerColumn = TableColumnRecord({
  id: 'owner',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "table.columnNames.owner"
  }),
  searchField: SearchFields.USER_ID_FIELD,
  width: 160
});
const BrandColumn = TableColumnRecord({
  id: 'brand',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "table.columnNames.brand"
  }),
  searchField: '',
  // TODO: Add support for brand sorting
  width: 160
});
const LastUpdatedColumn = TableColumnRecord({
  id: 'lastUpdated',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "table.columnNames.lastUpdated"
  }),
  searchField: SearchFields.UPDATED_AT_FIELD,
  width: 160
});
export default OrderedSet([NameColumn, LinksCreatedColumn, ViewsColumn, OwnerColumn, BrandColumn, LastUpdatedColumn]);